import { render } from "./todo-index.vue?vue&type=template&id=60344410"
import script from "./todo-index.vue?vue&type=script&lang=js"
export * from "./todo-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__